import React from "react";
import TemplateLabel from "../TemplateLabel";
import { DatePicker } from "@blueprintjs/datetime";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import { connect } from "react-redux";
import TemplateHint from "../TemplateHint";
import DatetimeSpinner from "./DatetimeSpinner";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const TemplateDate = (props ) => {
    let backgroundColor = props.appearance.match(new RegExp(/<#(.*?)\/>/), 'g');
    backgroundColor = backgroundColor !== null ? `#${backgroundColor[1]}` : "var(--primary-color)"; 
    
    if(props.appearance.indexOf("inline-1line")>-1){
        let format = ["month","date","year"]
        return (
            <>
                {
                    props.appearance.indexOf("text-nolabel") === -1 &&
                    <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                }
                <TemplateHint hint={props["hint::"+props.language]}/>
                <div className="d-flex justify-content-start">
                    {
                        format.map((flag) =>{
                            return <DatetimeSpinner appearance={props.appearance} flag={flag}/>
                        })
                    }
                </div>
            </>
        )
    }
    
    if(props.appearance.indexOf("inline")>-1){
    return (
        <div>
            <div className={"inline-wrapper d-flex flex-wrap justify-content-between"}>
                <div
                className="flex-shrink-1 flex-grow-1  order-1"
                style={{ flexBasis: "0%" }}
                >
                    {
                        props.appearance.indexOf("text-nolabel") === -1 &&
                        <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
                    }
                </div>
                <div style={{ order: 2, marginLeft: "1rem" }}>
                <label
                    className="btn btn-circle btn-icon tf-btn-sm"
                    data-toggle="modal"
                    data-target="#datetime_o2-modal"
                    style={{
                        backgroundColor: backgroundColor,
                        borderRadius: "50%",
                        color: "white",
                        boxShadow: "rgb(51, 51, 51) 0px 7px 6px -6px",
                        cursor: "pointer",
                        float: "right",
                        position: "relative"
                    }}
                >
                    <CalendarMonthIcon/>
                </label>
                </div>
            </div>
            <div>
                <TemplateHint hint={props["hint::"+props.language]}/>
            </div>
            <div>
                    <label style={{ fontSize: "var(--font-size)", color: "var(--answer-color)" }}>
                        2023-05-13
                    </label>
                </div>

        </div>
    )
    }
    return (
        <div>
            {
                props.appearance.indexOf("text-nolabel") === -1 &&
                <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
            }
            <TemplateHint hint={props["hint::"+props.language]}/>
            <DatePicker
            highlightCurrentDay = {true}
            canClearSelection	={false}
            />
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        display : state['questionsList'][props.questionId].display,
        required: state['questionsList'][props.questionId].required,
        readonly:  state['questionsList'][props.questionId].readonly,
        appearance: state['questionsList'][props.questionId].appearance,
        ["label::"+props.language] : state['questionsList'][props.questionId]["label::"+props.language],
        ["hint::"+props.language] : state['questionsList'][props.questionId]["hint::"+props.language],
        type:state['questionsList'][props.questionId].type
    };
}
export default connect(mapStateToProps)(TemplateDate);